//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'
// import DIC from '@/index/dictionary'

export default {
  props: {
    visible: {
      default: false
    },
    initialForm: {
      default: () => ({})
    }
  },
  data: function () {
    return {
      currentVisible: this.visible,
      loading: false,
      contactName: '',
      contactPhone: '',
      name: '',
      address: '',
      orders: [],
      dOrderAmount: 0,
      dFinalAmount: 0
    }
  },
  watch: {
    visible: {
      handler (val) {
        this.currentVisible = val
      },
      immediate: true
    }
  },
  components: {

  },
  mounted () {

  },
  methods: {
    handleOpen() {
      let data = _.pick(this.initialForm, 'dealerId', 'beginTime', 'endTime')
      this.loading = true
      this.$axios.get('/mtea/store/admin/report/dealer/info', { params: data }).then(res => {
        _.extend(this, res)
        this.dOrderAmount = _.reduce(res.orders, (memo, item) => {
          return memo + item.dOrderAmount
        }, 0)
        this.dFinalAmount = _.reduce(res.orders, (memo, item) => {
          return memo + item.dFinalAmount
        }, 0)
      }).finally(() => {
        this.loading = false
      })
    },
    handleClose(){
      _.extend(this, _.omit(this.$options.data(), 'currentVisible','loading'))
    }
  }
}
